import ApiService from './api.service';
import JwtService from './jwt.service';

export async function consultarRelacaoFluxo(endpoint, {signal, ...dados}) {
  if (!JwtService.getToken()) throw new Error('Sessão expirada');
  ApiService.setHeader();
  if (!signal) return (await ApiService.post(endpoint, dados)).data;
  const {data} = await ApiService.postOnce(endpoint, dados, {signal, timeout:60000});
  if (!Array.isArray(data)) throw new Error('Resposta inválida');
  return data;
}
